import React, { useState, useEffect } from 'react'
import axios from '../../lib/axios'
import { Box, Modal, Tooltip, TextField } from '@mui/material'
import AddButton from '../AddButton'
import TableShared from '../TableShared'
import { useTranslation } from "react-i18next"
import { useStateContext } from '../../context/ContextProvider'
import style from '../../styles/style'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'
import { handleAxiosError } from '../../helpers/helper'
import { ReactMultiEmail } from 'react-multi-email';

const PurchaseAddresses = ({ no, id, setIsLoading }) => {


    const { t } = useTranslation()
    const { config, pusher } = useStateContext()

    const [purchaseAddress, setPurchaseAddress] = useState([])
    const [open, setOpen] = useState(false)
    const [PAname_search, setPAname_search] = useState('')
    const [PAcode_search, setPAcode_search] = useState('')

    /* fields */
    const [code, setCode] = useState('')
    const [name, setName] = useState('')
    const [address, setAddress] = useState('')
    const [address2, setAddress2] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [zip, setZip] = useState('')
    const [salesContactEmail, setSalesContactEmail] = useState([])
    const [accountingContactEmail, setAccountingContactEmail] = useState([])
    const [contact, setContact] = useState('')
    const [phone, setPhone] = useState('')
    const [pickupInstructions, setPickupInstructions] = useState('')

    useEffect(() => {

        const channeldelete = pusher.subscribe(`${localStorage.getItem('client_id')}-purchaseaddress-deleted`)
        const channelcreate = pusher.subscribe(`${localStorage.getItem('client_id')}-purchaseaddress-created`)
        const channelupdate = pusher.subscribe(`${localStorage.getItem('client_id')}-purchaseaddress-updated`)

        channeldelete.bind(`${localStorage.getItem('client_id')}-purchaseaddress-deleted-event`, data => {
            if(Number(id) == Number(data.vendor_id)) {
                getPurchaseAddress(id)
            }
        })

        channelcreate.bind(`${localStorage.getItem('client_id')}-purchaseaddress-created-event`, data => {
            if(Number(id) == Number(data.vendor_id)) {
                getPurchaseAddress(id)
            }
        })

        channelupdate.bind(`${localStorage.getItem('client_id')}-purchaseaddress-updated-event`, data => {
            if(Number(id) == Number(data.vendor_id)) {
                getPurchaseAddress(id)
            }
        })

        return (() => {
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-purchaseaddress-deleted`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-purchaseaddress-created`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-purchaseaddress-updated`)
        })
    }, [])

    useEffect(() => {
        function handleKeyDown(e) {
            if (e.keyCode == '13') {
                if (open) createPurchaseAddress()
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [open, code, name, address, address2, city, state, zip, contact, phone, pickupInstructions]);

    useEffect(() => {
        if (id) getPurchaseAddress(id)
    }, [id])


    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setCode('')
        setName('')
        setAddress2('')
        setAddress('')
        setZip('')
        setSalesContactEmail([])
        setAccountingContactEmail([])
        setCity('')
        setState('')
        setPhone('')
        setContact('')
        setPickupInstructions('')
    }

    const getPurchaseAddress = async (id) => {
        setIsLoading(true)
        await axios.get(`/api/purchase-addresses?vendor_id=${id}`, config)
            .then(res => {
                const data = res.data
                setPurchaseAddress(data)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const createPurchaseAddress = async () => {
        setIsLoading(true)
        const formData = {}

        formData['code'] = code
        formData['name'] = name
        formData['address'] = address
        formData['address2'] = address2
        formData['city'] = city
        formData['state'] = state
        formData['zip'] = zip
        formData['sales_contact_email'] = salesContactEmail.join(";")
        formData['accounting_contact_email'] = accountingContactEmail.join(";")
        formData['contact'] = contact
        formData['phone'] = phone
        formData['vendor_id'] = id

        formData['pickup_instructions'] = pickupInstructions

        await axios.post(`/api/purchase-addresses`, formData, config).then(({ data }) => {
            Swal.fire({
                icon: "success",
                customClass: 'success',
                showCloseButton: true,
                iconColor: '#00B78E',
                text: data.success.message
            })
            handleClose()
        }).catch(({ response }) => {
            handleAxiosError({response: response})
        }).finally(() => {
            setIsLoading(false)
        })
    }



    const items = purchaseAddress.filter(data => {
        if (PAname_search === null)
            return data
        if (data.name.toLocaleLowerCase().includes(PAname_search.toLocaleLowerCase()))
            return data
    })

    const filtered = items.filter(data => {
        if (PAcode_search === null)
            return data
        if (data.code.toLocaleLowerCase().includes(PAcode_search.toLocaleLowerCase()))
            return data
    })


    const columns = [
        {
            field: 'code',
            headerName: t('code'),
            flex: 1
        },
        {
            field: 'name',
            headerName: t('name'),
            flex: 1
        },
        {
            field: 'address',
            headerName: t('address'),
            flex: 1
        },
        {
            field: 'city',
            headerName: t('city'),
            flex: 1
        },
        {
            field: 'state',
            headerName: t('state'),
            flex: 1
        },
        {
            field: 'zip',
            headerName: t('zip'),
            flex: 1
        },
        {
            field: 'actions',
            headerName: t('actions'),
            sortable: false,
            flex: 0.5,
            cellClassName: 'padding-0',
            renderCell: (params) => <ShipToActions params={params} />
        }
    ]


    return (
        <>
            <div className='pb-5 bg-white mb-2 rounded-md'>
                <div className='flex justify-between items-center p-5 border-b'>
                    <p style={{ fontWeight: 600, fontSize: '16px' }}>{t('purchase_addresses')}</p>
                    <Tooltip disableInteractive title={t('addPA')} placement='bottom'>
                        <div>
                            <AddButton onClick={handleOpen}><i className="fa-solid fa-plus"></i></AddButton>
                        </div>
                    </Tooltip>
                </div>
                <div className='flex justify-between items-end w-full pb-5 border-b'>
                    <div className='px-5 pt-5 w-full'>
                        <div className='flex justify-between items-center search'>
                            <input type="text" placeholder={t('search_by_PAcode')} className='w-full bg-[#f5f5f5] border-0 focus:ring-0 p-0 font-bold place' onChange={(e) => setPAcode_search(e.target.value)} />
                            <i className="fa-solid fa-magnifying-glass" style={{ color: 'rgba(0,0,0,.54)' }}></i>
                        </div>
                    </div>
                    <div className='px-5 pt-5 w-full'>
                        <div className='flex justify-between items-center search'>
                            <input type="text" placeholder={t('search_by_PAname')} className='w-full bg-[#f5f5f5] border-0 focus:ring-0 p-0 font-bold place' onChange={(e) => setPAname_search(e.target.value)} />
                            <i className="fa-solid fa-magnifying-glass" style={{ color: 'rgba(0,0,0,.54)' }}></i>
                        </div>
                    </div>

                </div>
                <div className='pt-3'>
                    <TableShared items={filtered} columns={columns} />
                </div>
            </div>


            <Modal open={open} onClose={handleClose}>
                <Box sx={style}>
                    <div className='flex border-b justify-between items-center p-5 w-full bg-white' style={{ borderRadius: '5px 5px 0 0' }}>
                        <div className='flex items-center justify-between w-full leading-none'>
                            <p className='text-[18px] font-[600] text-[#333333] flex items-center'><span className='text-[#650D1B] text-[35px] mr-4'>•</span> {t('addPA')}</p>
                            <div style={{ transform: "rotate(45deg)" }} className="font-[600] text-[#333333]">
                                <button onClick={handleClose}><i className="fa-solid fa-plus"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className='w-full bg-white h-full'>
                        <div className='bg-white p-6 w-full'>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('code')} *</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={code} onChange={(e) => { setCode(e.target.value) }} />
                                </div>
                            </div>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('name')} *</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={name} onChange={(e) => { setName(e.target.value) }} />
                                </div>
                            </div>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('address')} *</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                                </div>
                            </div>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('address2')}</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={address2} onChange={(e) => { setAddress2(e.target.value) }} />
                                </div>
                            </div>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('city')} *</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={city} onChange={(e) => { setCity(e.target.value) }} />
                                </div>
                            </div>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('state')} *</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={state} onChange={(e) => { setState(e.target.value) }} />
                                </div>
                            </div>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('zip')} *</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={zip} onChange={(e) => { setZip(e.target.value) }} />
                                </div>
                            </div>

                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('sales_contact_email')}</p>
                                <ReactMultiEmail
                                    className="custom-react-multi-email-class"
                                    emails={salesContactEmail}
                                    onChange={(_emails) => setSalesContactEmail(_emails)}
                                    getLabel={(_email, index, removeEmail) => {
                                        return (
                                            <div data-tag key={index}>
                                                <div data-tag-item>{_email}</div>
                                                <span data-tag-handle onClick={() => removeEmail(index)}>
                                                    ×
                                                </span>
                                            </div>
                                        )
                                    }}
                                />
                            </div>

                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('accounting_contact_email')}</p>
                                <ReactMultiEmail
                                    className="custom-react-multi-email-class"
                                    emails={accountingContactEmail}
                                    onChange={(_emails) => setAccountingContactEmail(_emails)}
                                    getLabel={(_email, index, removeEmail) => {
                                        return (
                                            <div data-tag key={index}>
                                                <div data-tag-item>{_email}</div>
                                                <span data-tag-handle onClick={() => removeEmail(index)}>
                                                    ×
                                                </span>
                                            </div>
                                        )
                                    }}
                                />
                            </div>

                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('contact')}</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={contact} onChange={(e) => { setContact(e.target.value) }} />
                                </div>
                            </div>
                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('phone')}</p>
                                <div className='w-full'>
                                    <TextField
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}
                                        type="text" className='w-full' name="drop_trailer_no" value={phone} onChange={(e) => { setPhone(e.target.value) }} />
                                </div>
                            </div>

                            <div className='w-full pb-4'>
                                <p className="text-[14px] text-[#718096]">{t('pickup_instructions')}</p>
                                <TextField
                                    multiline
                                    rows={3}
                                    value={pickupInstructions}
                                    onChange={e => setPickupInstructions(e.target.value)}
                                    sx={{
                                        width: '100%',
                                        background: '#FCFCFC',
                                        '.MuiOutlinedInput-input': {
                                            padding: '9px !important'
                                        },
                                        boxShadow: 'none',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            border: '1px solid #EEEFF2 !important'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className='w-full flex justify-end px-6 pb-14'>
                            <button type="button" onClick={createPurchaseAddress} className=' text-white font-[700] rounded-md py-2.5 px-5 uppercase text-[14px] bg-[#DBA34B] hover:bg-[#CF7300] disabled:bg-[#B8B7BC]'>
                                <span className='pr-2'><i className="fa-solid fa-plus"></i></span> {t('create')}
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default PurchaseAddresses



const ShipToActions = (params) => {

    const { t } = useTranslation();
    const { config } = useStateContext()

    const deletePurchaseAddress = async (id, force = false) => {
        if(!force) {
            const isConfirm = await Swal.fire({
                title: t('title_delete') + t('del_pa') + params.params.row.code + "?",
                text: t('text_delete'),
                icon: 'warning',
                customClass: 'error',
                showCloseButton: true,
                iconColor: '#FF0000',
                reverseButtons: true,
                showCancelButton: true,

                confirmButtonText: t('confirmButtonText_delete'),
                cancelButtonText: t('cancel')
            }).then((result) => {
                return result.isConfirmed
            })

            if (!isConfirm) {
                return
            }
        }

        let url = `/api/purchase-addresses/${id}`;

        if(force) {
            url = url.concat('?template-destroy-confirmed=true');
        }

        await axios
            .delete(url, params.config)
            .then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    customClass: 'success',
                    showCloseButton: true,
                    iconColor: '#00B78E',
                    text: data.success.message
                })
            })
            .catch(async ({ response }) => {
                if(response.status === 409) {
                        const isConfirm = await Swal.fire({
                        title: t('warning'),
                        text: response?.data?.warning?.message,
                        icon: 'warning',
                        customClass: 'warning2',
                        showCloseButton: true,
                        iconColor: '#FFCA28',
                        reverseButtons: true,
                        showCancelButton: true,

                        confirmButtonText: t('go'),
                        cancelButtonText: t('cancel')
                    }).then((result) => {
                        return result.isConfirmed
                    })

                    if (!isConfirm) {
                        return
                    } else {
                        await deletePurchaseAddress(id, true);
                    }
                } else {
                    handleAxiosError({ response: response })
                }
            })
    }


    return (
        <>
            <div className='flex justify-start gap-1'>
                <Tooltip disableInteractive title={t('edit')} placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <Link to={`/purchase-address/${params.params.row.id}`}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-pencil"></i></span></Link>
                    </div>
                </Tooltip>
                <Tooltip disableInteractive title={t('delete')} placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200" onClick={() => deletePurchaseAddress(params.params.row.id)}><i className="fa-solid fa-trash"></i></span>
                    </div>
                </Tooltip>
            </div>
        </>
    )
}
